import { UntypedFormControl, UntypedFormArray } from '@angular/forms';

export class Detail {
  partNumber: UntypedFormControl;
  gtin: UntypedFormControl;
  gtinQualifier: UntypedFormControl;
  brandLabel: UntypedFormControl;
  hasFitments: UntypedFormControl;
  partType: UntypedFormControl;
  nationalPopularityCode: UntypedFormControl;
  lifeCycleStatus: UntypedFormControl;
  minimumOrderQuantity: UntypedFormControl;
  itemQuantity: UntypedFormControl;
  itemQuantityUom: UntypedFormControl;
  qualifier: UntypedFormControl;
  hazardousMaterialCode: UntypedFormControl;
  taxable: UntypedFormControl;
  subBrand: UntypedFormControl;
  category: UntypedFormControl;
  effectiveDate: UntypedFormControl;
  availableDate: UntypedFormControl;
  emissionCode: UntypedFormControl;
  basePartNumber: UntypedFormControl;
  productGroup: UntypedFormControl;
  unspscCode: UntypedFormControl;
  vmrsCode: UntypedFormControl;
  coreClass: UntypedFormControl;
  coreGroup: UntypedFormControl;
  corePartNumber: UntypedFormControl;
  coreReturnDaysToExpiry: UntypedFormControl;
  returnCode: UntypedFormControl;
  warrantyDistance: UntypedFormControl;
  warrantyDistanceUom: UntypedFormControl;
  warrantySpecial: UntypedFormControl;
  warrantySpecialUom: UntypedFormControl;
  warrantyTime: UntypedFormControl;
  warrantyTimeUom: UntypedFormControl;
  refurbishedPart: UntypedFormControl;
  remanufacturedPart: UntypedFormControl;
  oemPartNumber: UntypedFormControl;
  oemBrand: UntypedFormControl;
  originalSupplierPartNumber: UntypedFormControl;
  originalSupplierName: UntypedFormArray;
  oldPartNumber: UntypedFormArray;
  partNumberSupersededTo: UntypedFormArray;
}
